import '@/lib/polyfills';
// import Notifications from '@/components/NotificationPlugin';
// vue3-migration-todo -- настроить VeeValidate
// import VeeValidate from 'vee-validate';
import GlobalDirectives from '@/lib/globalDirectives';
import GlobalComponents from '@/lib/globalComponents';
import Sidebar from '@/components/SidebarPlugin';
import AppNotifications from '@/views/Notifications';
// import 'bootstrap/scss/bootstrap.scss';
import '@/assets/sass/tailwind.css';
import '@/assets/css/bootstrap-remove.css';
import '@/assets/sass/custom-ui.scss';
import 'es6-promise/auto';
import '@noction/vue-bezier/styles';
// import 'select2/dist/css/select2.css';

export default {
  install(Vue) {
    Vue.use(GlobalComponents);
    Vue.use(GlobalDirectives);
    Vue.use(Sidebar);
    // Vue.use(Notifications);
    // Vue.use(VeeValidate, { fieldsBagName: 'veeFields' });
    Vue.use(AppNotifications);
  },
};
